import { create } from 'zustand';
import { RawPermission } from '../@types';
import LocalStorageService from './local-storage';

interface PermissoesStore {
  permissions: RawPermission[];
  setPermissions: (permissions: RawPermission[]) => void;
}

const usePermissoesStore = create<PermissoesStore>((set) => ({
  permissions: LocalStorageService.getItem('user')?.funcao?.permissions ?? [],
  setPermissions: (permissions) => set({ permissions }),
}));

export default usePermissoesStore;
